import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Logo } from "./Logo";
import { finalFeatures, heroStats } from "../data/content";
export function FinalCta() {
  return <section className="bg-ink px-4 py-20 text-white" aria-labelledby="final-title" data-id="element-108" data-mp="19g0bjea05oib">
      <div className="mx-auto max-w-4xl text-center" data-id="element-109" data-mp="15d414aum8ypg">
        <h2 id="final-title" className="font-heading text-3xl font-bold uppercase leading-tight md:text-4xl" data-id="element-110" data-mp="15fgesbtccmwp">
          Stop designing every project <span className="text-brand" data-id="element-111" data-mp="1eetsxhsetznr">from scratch.</span>
        </h2>
        <div className="mt-6 space-y-1 text-white/80" data-id="element-112" data-mp="1t2yd6q742j8n">
          <p data-id="element-113" data-mp="1t1n1m47fc76z">You already have the tools.</p>
          <p data-id="element-114" data-mp="1o3v5sz3ns0xi">You already have the motivation.</p>
          <p className="font-semibold text-white" data-id="element-115" data-mp="1o5696xt6z6o3">Now you have the plans.</p>
        </div>
        <dl className="mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-6 md:grid-cols-4" data-id="element-116" data-mp="224o2nqhfn83s">
          {heroStats.map(s => <div key={s.label} data-id="element-117" data-mp="1x6curlap77o7">
              <dt className="sr-only" data-id="element-118" data-mp="n5m7g5iysa3g">{s.label}</dt>
              <dd className="font-heading text-4xl font-extrabold text-brand" data-id="element-119" data-mp="n6w54tlwng9k">{s.value}</dd>
              <dd className="mt-1 font-heading text-xs font-semibold uppercase text-white/80" data-id="element-120" data-mp="s5gws4n3crme">{s.label}</dd>
            </div>)}
        </dl>
        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-121" data-mp="122vd8490lgep">
          {finalFeatures.map(f => <li key={f} className="flex items-center gap-1.5" data-id="element-122" data-mp="16505oznq86zr">
              <CheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-123" data-mp="162mamqt1qus7" />
              {f}
            </li>)}
        </ul>
        <div className="mt-12" data-id="element-124" data-mp="1ftqgn10qv5aw">
          <Logo tone="light" data-id="element-125" data-mp="1fus2m0jatc7e" />
        </div>
        <p className="mt-4 font-heading text-lg font-bold uppercase" data-id="element-126" data-mp="1ktd0htb2vjso">Build smarter.</p>
        <p className="font-heading text-lg font-bold uppercase text-brand" data-id="element-127" data-mp="1kv7c2h0glzk3">Build with less guesswork.</p>
        <div className="mt-8" data-id="element-128" data-mp="1tu155xel07sw">
          <CtaButton label="Get instant access now" caption="Instant Digital Download" captionTone="light" data-id="element-129" data-mp="1tt9mto9zw6kk" />
        </div>
      </div>
    </section>;
}